import c from "../../utils/constants";

class BotSessionsController {
  constructor(BotSessionsService, FilterService, $scope) {
    "ngInject"

    this.botSessionsService = BotSessionsService;
    this.filterService = FilterService;
    this.$scope = $scope;
    this.gridOptions = this.getGridOptions();

    // TODO: Figure out a better approach.
    window.processLineBreaks = function(text) {
        if (!text)
          return "";

        var regexp = new RegExp('\n', 'g');
        return text.replace(regexp, '<br>');
    }
  }

  getGridOptions() {

    return {
      dataSource: this.botSessionsService.getDataSource(this.dataSourceFetchSuccessCallback.bind(this)),
      sortable: true,
      pageable: true,
      resizable: true,
      height: "90vh",
      noRecords: {
        template: "No match found. Change your filter criteria."
      },
      columns: [
        { field: "userName", title: "User Name", filterable: false, width: "6rem" },        
        { field: "botName", title: "Bot Name", filterable: false, width: "6rem" },        
        { field: "channelId", title: "Channel Id", filterable: false, width: "6rem" },        
        // { field: "jugglerId", title: "Juggle St Account", filterable: false, width: "4rem" },        
        { field: "startDate", title:"Start", width: "6rem", template: `<span> #= kendo.toString(new Date(startDate), 'dd/MM/yy') # </span>` },        
        { field: "lastUpdateDate", title:"Last Update", width: "6rem", template: `<span> #= kendo.toString(new Date(lastUpdateDate), 'dd-MM-yy @ hh:mm:ss') # </span>` },        
      ],
      detailTemplate: kendo.template($("#bot-session-detail-template").html()),
      detailInit: this.detailInit,
      dataBound: this.dataBound
    }
  }

  applyFilters() {
    this.gridOptions.dataSource.filter(this.filterService.getAppliedFilters());
  }

  dataSourceFetchSuccessCallback(e) {
    this.botSessionsMatchCount = this.gridOptions.dataSource.total();
    this.$scope.$apply();
  }

  detailInit(e) {
    var detailRow = e.detailRow;

    detailRow.find(".tabstrip").kendoTabStrip({
        animation: {
            open: { effects: "fadeIn" }
        }
    });

    let sessionEntries = {
      data: e.data.sessionEntries,
      total: e.data.sessionEntries.length
    };

    detailRow.find(".bot-session-detail-conversation").kendoGrid({
        dataSource: {
            data: sessionEntries,
            pageSize: 50,
            schema: { 
              data: "data",
              total: "total"              
          },
        },
        scrollable: false,
        sortable: false,
        pageable: true,
        columns: [
            { field: "activityTypeName", title:"Activity", width: "4rem" },
            { field: "textScript", title:"Script", width: "12rem" },
            { field: "fromName", title:"From", width: "4rem" },
            // { field: "recipientName", title:"To", width: "4rem" },            
            // { field: "text", title:"Message", width: "12rem" },            
            { field: "text", title:"Message", width: "12rem", template: `<span> #= window.processLineBreaks(text) # </span>` },
            { field: "entryDate", title:"Time", width: "4rem", template: `<span> #= kendo.toString(new Date(entryDate), 'dd/MM hh:mm:ss') # </span>` },
            { field: "flowType", title:"Flow/Stream", width: "4rem" },
        ]
    });
   }

   dataBound(e) {    
      this.expandRow(this.tbody.find("tr.k-master-row").first());
   }

}

export default BotSessionsController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/bot-sessions/bot-sessions.controller.js
 **/